import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useConnectWs from "../../../hooks/useConnectWs";
import { useQuery } from "urql";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDownloadExcel } from "react-export-table-to-excel";
import HistoryList from "./HistoryList";

const QUERY = `
query($first: Int = 2, $after:String="", $id_eq: ID = "") {
    activitiesConnection(orderBy: createdAt_DESC, where: {OR: {from: {id_eq: $id_eq}}, to: {id_eq: $id_eq}}, first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          type
          id
          to {
            id
          }
          from {
            id
          }
          createdAt
          action
          extrinsic {
            hash
            success
          }
        }
      }
    }
  }
`;

const History = () => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const [api, setApi] = useConnectWs();
  const { account } = useSelector((state) => state?.account);
  const first = 10;
  const [after, setAfter] = useState("0");
  const [id_eq, setIDEQ] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageInfo, setPageInfo] = useState(null);
  const [dataHistory, setDataHistory] = useState([]);
  const [result, reexecuteQuery] = useQuery({
    query: QUERY,
    variables: { first, after, id_eq },
  });

  useEffect(() => {
    if (account && api) {
      setIDEQ(account.address);
    }
  }, [account, api]);

  useEffect(() => {
    if (id_eq) {
      getListHistory();
    }
  }, [id_eq, after]);

  useEffect(() => {
    if (result.fetching) return;
    if(!result.data) return;
    setTotalCount(result?.data.activitiesConnection.totalCount);
    setPageInfo(result?.data.activitiesConnection.pageInfo);
    const tmp = [...dataHistory, ...result?.data.activitiesConnection.edges];
    setDataHistory(tmp);
  }, [result, reexecuteQuery]);

  const getListHistory = () => {
    reexecuteQuery({ requestPolicy: "network-only" });
  };

  const fetchMoreData = () => {
    let tmp = Number(after);
    setAfter(String(tmp + first));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Rivius Network History table",
    sheet: "History",
  });

  console.log("result", result);

  return (
    <div className="pages-history">
      {/* <div className="layer"></div> */}
      <div className="head">
        <div className="left">{t("history.History")}</div>
        <div className="right g-buttonHover" onClick={onDownload}>
          <img src="/images/history1.svg" alt="" />
          {t("history.View report")}
        </div>
      </div>
      <div className="table">
        <InfiniteScroll
          dataLength={totalCount}
          next={fetchMoreData}
          hasMore={pageInfo ? pageInfo.hasNextPage : false}
          loader={<h4>Loading...</h4>}
          scrollableTarget="g-content"
        >
          <table ref={tableRef}>
            <thead>
              <tr>
                <th>{t("history.Action")}</th>
                <th>{t("history.From")}</th>
                <th>{t("history.To")}</th>
                <th>{t("history.Status")}</th>
                <th>{t("history.Created")}</th>
              </tr>
            </thead>
            <tbody>
              <HistoryList data={dataHistory} />
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default History;
